"use strict"

import angular from "angular"

angular.module("uCountitUiApp").directive("ucImgFallback", () => ({
  restrict: "A",
  link(scope, element, attrs) {
    const fallbackSrc = attrs.ucImgFallback || "/assets/images/no-image.svg"

    const onError = () => {
      const currentSrc = element.attr("src")
      if (!currentSrc || currentSrc === fallbackSrc) {
        return
      }
      element.attr("src", fallbackSrc)
    }

    element.on("error", onError)
    scope.$on("$destroy", () => element.off("error", onError))
  },
}))
